import { API_BASE_URL, getApiPaths, API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class InstituteService {


  static getInstitute(item) {

    let api = `${API_BASE_URL}${API_PATHS.getInstitute}`;
    const params = new URLSearchParams();

    if (item?.limit) params.append("limit", item.limit);
    if (item?.page) params.append("page", item.page);
    if (item?.id) params.append("id", item.id);
    if ([...params].length > 0) {
      api += `?${params.toString()}`;
    }
    return axiosInstance
      .get(api, item)
  }


  static addInstitute(data) {

    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addInstitute}`;
    return axiosInstance
      .post(api, data)
  }


  static deleteActivity(id) {
    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);
    let api = '';
    api = `${API_BASE_URL}${dynamicPaths.deleteActivity}?id=${id}`;

    return axiosInstance
      .delete(api)
  }


}

export default InstituteService;
